import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";

export default function CountUp({ value, duration = 1.4 }) {
  const [, prefix = "", numStr = "0", suffix = ""] = /^([^\d]*)(\d+(?:\.\d+)?)(.*)$/.exec(value) || [];
  const decimals = numStr.includes(".") ? numStr.split(".")[1].length : 0;
  const target = parseFloat(numStr) || 0;

  const shouldReduceMotion = useReducedMotion();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const [display, setDisplay] = useState(shouldReduceMotion ? target.toFixed(decimals) : (0).toFixed(decimals));

  useEffect(() => {
    if (!inView || shouldReduceMotion) return;
    const controls = animate(0, target, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(v.toFixed(decimals)),
    });
    return controls.stop;
  }, [inView, shouldReduceMotion, target, duration, decimals]);

  return <span ref={ref}>{prefix}{display}{suffix}</span>;
}
